import React, { useEffect } from 'react';
import { TourCard } from '../components/TourCard';
import { groupTours } from '../mockData';
import { Users } from 'lucide-react';

export const GroupTours = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="group-tours-page">
      {/* Hero Section */}
      <section className="relative h-[300px] flex items-center justify-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1507525428034-b723cf961d3e)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-sky-900/80 to-emerald-900/80"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <Users className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-5xl font-bold mb-4">Group Tours</h1>
          <p className="text-xl">Travel together, create memories together</p>
        </div>
      </section>

      {/* Tours Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Perfect for Groups & Corporate Outings</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Whether it's a family reunion, friends getaway, or corporate team building – our group tour packages 
              are designed to bring people together. Enjoy special group discounts and customized itineraries.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {groupTours.map((tour) => (
              <TourCard key={tour.id} tour={tour} />
            ))}
          </div>
          
          <div className="mt-12 bg-gradient-to-r from-sky-50 to-emerald-50 p-8 rounded-lg max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Group Tour Benefits</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
              <div className="flex items-start space-x-2">
                <Users className="w-5 h-5 text-sky-600 flex-shrink-0 mt-1" />
                <span>Special group discounts (10+ people)</span>
              </div>
              <div className="flex items-start space-x-2">
                <Users className="w-5 h-5 text-sky-600 flex-shrink-0 mt-1" />
                <span>Customized itineraries</span>
              </div>
              <div className="flex items-start space-x-2">
                <Users className="w-5 h-5 text-sky-600 flex-shrink-0 mt-1" />
                <span>Dedicated tour manager</span>
              </div>
              <div className="flex items-start space-x-2">
                <Users className="w-5 h-5 text-sky-600 flex-shrink-0 mt-1" />
                <span>Team building activities</span>
              </div>
            </div>
            <p className="text-center mt-6 text-gray-600">
              <strong>Contact us for custom group packages:</strong> +91 9833280079
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};